/** Drowning In The Talent Pool — Spotify show page. */
export const SPOTIFY_PODCAST_URL = 'https://open.spotify.com/show/6YtQl7mhoDrsGI1W7FFoWa';

/** Drowning In The Talent Pool — Apple Podcasts show page. */
export const APPLE_PODCAST_URL =
  'https://podcasts.apple.com/us/podcast/drowning-in-the-talent-pool/id1696595949';
